import { gql } from '@apollo/client';

export const GET_COUPONS = gql`
  query GetCoupons($hostId: ID) {
    coupons(hostId: $hostId) {
      id
      code
      name
      startAt
      endAt
      applyToOwnerId
      applyToProductType
      applyToCategory
      minDays
      isActive
      applyByDateOrTrip
      priceAlgorithm
      category
      applyToPriceOf
      percentageValue
      fixAmountValue
      createdAt
      updatedAt
      applyToOwner {
        id
        displayName
        email
      }
      applyToGuests {
        id
        firstName
        lastName
        email
        displayName
      }
    }
  }
`;

export const GET_COUPON = gql`
  query GetCoupon($id: ID!) {
    coupon(id: $id) {
      id
      code
      name
      startAt
      endAt
      applyToOwnerId
      applyToProductType
      applyToCategory
      minDays
      isActive
      applyByDateOrTrip
      priceAlgorithm
      category
      applyToPriceOf
      percentageValue
      fixAmountValue
      createdAt
      updatedAt
      applyToOwner {
        id
        displayName
        email
      }
      applyToGuests {
        id
        firstName
        lastName
        email
        displayName
      }
    }
  }
`;

export const CREATE_COUPON = gql`
  mutation CreateCoupon($input: CreateCouponInput!) {
    createCoupon(input: $input) {
      id
      code
      name
      startAt
      endAt
      applyToOwnerId
      applyToProductType
      applyToCategory
      minDays
      isActive
      applyByDateOrTrip
      priceAlgorithm
      category
      applyToPriceOf
      percentageValue
      fixAmountValue
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_COUPON = gql`
  mutation UpdateCoupon($input: UpdateCouponInput!) {
    updateCoupon(input: $input) {
      id
      code
      name
      startAt
      endAt
      applyToOwnerId
      applyToProductType
      applyToCategory
      minDays
      isActive
      applyByDateOrTrip
      priceAlgorithm
      category
      applyToPriceOf
      percentageValue
      fixAmountValue
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_COUPON = gql`
  mutation DeleteCoupon($id: ID!) {
    deleteCoupon(id: $id)
  }
`;

export const VALIDATE_COUPON = gql`
  query ValidateCoupon(
    $code: String!
    $carId: ID
    $guestId: ID
    $startAt: Float
    $endAt: Float
    $totalDays: Int
  ) {
    validateCoupon(
      code: $code
      carId: $carId
      guestId: $guestId
      startAt: $startAt
      endAt: $endAt
      totalDays: $totalDays
    ) {
      isValid
      errorMessage
      discountAmount
      couponId
    }
  }
`;

export const SEARCH_GUESTS = gql`
  query SearchGuests($firstName: String!) {
    searchGuests(firstName: $firstName) {
      id
      firstName
      lastName
      email
      displayName
    }
  }
`;
